import Popover, { PopoverProps } from 'client/components/core/Popover'
import { mimeTypes } from 'client/constants/editorSettings'
import { pageSelectors, useFiles, usePage } from 'client/store'
import { DataFile } from 'client/store/files/filesReducer'
import filesSelectors from 'client/store/files/filesSelectors'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import {
  BackgroundInterface,
  BackgroundStylesInterface,
} from 'common/types/background-interfaces'
import React, { useState } from 'react'
import { ImageCircle } from 'src/editor/shared/ui-lib/image-circle'
import { ImageSettingsPanel } from 'src/editor/shared/ui-lib/image-settings-panel'
import { FileManager } from 'src/editor/shared/ui-lib/uploader/file-manager'

export type ImageControlStandaloneProps = {
  fileId: BackgroundInterface['backgroundFileId']
  popoverProps?: Partial<PopoverProps>
  update?: (value: BackgroundStylesInterface) => void
  backgroundPosition?: BackgroundStylesInterface
} & (
  | {
      updateBackgroundFile: (value: DataFile | null) => void
      updateBackgroundFileId?: never
    }
  | {
      updateBackgroundFile?: never
      updateBackgroundFileId: (
        value: BackgroundInterface['backgroundFileId'],
      ) => void
    }
)

export const ImageControlStandalone = ({
  fileId,
  popoverProps,
  updateBackgroundFileId,
  backgroundPosition,
  update,
  updateBackgroundFile,
}: ImageControlStandaloneProps) => {
  const [isOpenBackgroundPosition, setIsOpenBackgroundPosition] =
    useState(false)
  const [isOpenFileManager, setIsOpenFileManager] = useState(false)
  const pageType = usePage(pageSelectors.getPageType)
  const isLecture = pageType === PageTypeEnum.Lecture
  const backgroundImageFile = useFiles(state =>
    filesSelectors.getFileById(state, fileId),
  )

  const updateFile = (file: DataFile) => {
    updateBackgroundFile?.(file)
    updateBackgroundFileId?.(file.id)
  }

  const removeFile = () => {
    updateBackgroundFile?.(null)
    updateBackgroundFileId?.(null)
  }

  return (
    <>
      {!fileId ? (
        <button
          type="button"
          className="cursor-pointer text-M text-textLink"
          onClick={() => setIsOpenFileManager(true)}
        >
          Upload
        </button>
      ) : (
        <Popover
          ignoredEventTypes={['focusout']}
          isOpen={isOpenBackgroundPosition}
          setIsOpen={setIsOpenBackgroundPosition}
          offsetValue={10}
          flipOptions={{
            fallbackAxisSideDirection: 'end',
            fallbackPlacements: ['bottom'],
          }}
          strategyValue="fixed"
          placement="right"
          triggerElement={
            <span>
              <ImageCircle
                path={backgroundImageFile?.path}
                isActive={isOpenBackgroundPosition}
              />
            </span>
          }
          popoverContent={
            <ImageSettingsPanel
              onClose={() => setIsOpenBackgroundPosition(false)}
              onDelete={removeFile}
              backgroundPosition={backgroundPosition}
              onUpdateBackgroundPosition={update}
              isLecture={isLecture}
            />
          }
          {...popoverProps}
        />
      )}

      {!fileId && isOpenFileManager && (
        <FileManager
          closeFileManager={() => setIsOpenFileManager(false)}
          mimeTypes={mimeTypes.image}
          fileType="image"
          onInsert={updateFile}
        />
      )}
    </>
  )
}
